import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../context/authContext';


const PrivateRoute = ({ children }) => {
    const navigate = useNavigate();
    const auth = JSON.parse(localStorage.getItem("za_token"));


    return (
        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        auth?.token ?
            children
            :
            <Navigate to="/auth/login" />

    );
};

export default PrivateRoute;